<template>
  <div>
    <form action="" @submit.prevent="onSubmit" v-if="profileData">
      <CRow class="d-flex justify-content-start align-items-center px-3">
        <p>
          {{ $t("models.role.userSettings.intro") }}
        </p>
      </CRow>

      <CCard class="border-0 bg-light px-2" v-if="roleData">
        <CCardHeader class="bg-light">
          <div class="card-title">
            {{ $t("role.profile.tab_logos.title") }}
          </div>
        </CCardHeader>
        <CCardBody>
          <ProfileLogo v-model="roleData" />
        </CCardBody>
      </CCard>

      <CCard class="border-0" v-if="roleData">
        <CCardHeader>
          <div class="card-title">
            {{ $t("models.role.userSettings.general.title") }}
          </div>
          <div class="card-subtitle">
            {{ $t("models.role.userSettings.general.subtitle") }}
          </div>
        </CCardHeader>
        <CCardBody>
          <div class="d-flex justify-content-center" v-if="loading">
            <CSpinner color="info" />
          </div>

          <!-- desc_short -->
          <CRow>
            <CCol md="12">
              <CTextarea
                :placeholder="$t('models.role.desc_short_info')"
                :label="$t('models.role.desc_short')"
                v-model="profileData.desc_short"
                rows="9"
              />
            </CCol>
          </CRow>

          <!-- info_contact -->
          <CRow>
            <CCol md="12">
              <CTextarea
                :placeholder="$t('models.role.info_contact_info')"
                :label="$t('models.role.info_contact')"
                v-model="profileData.info_contact"
                rows="9"
              />
            </CCol>
          </CRow>

          <!-- desc_zone -->
          <CRow>
            <CCol md="12">
              <CTextarea
                :placeholder="$t('models.role.desc_zone')"
                :label="$t('models.role.desc_zone')"
                v-model="profileData.desc_zone"
                rows="9"
              />
            </CCol>
          </CRow>

          <vue-ladda
            :loading="saving"
            data-style="zoom-in"
            button-class="btn btn-primary mt-3"
            type="submit"
          >
            {{ $t("common.editor.button.save") }}
          </vue-ladda>
        </CCardBody>
      </CCard>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { apiPatch } from "../../../helpers/apiHelper";
import ProfileLogo from "./ProfileLogo";

export default {
  components: {
    ProfileLogo,
  },

  props: {
    roleData: Object,
  },

  name: "ProfileInfoNew",

  data() {
    return {
      loading: false,
      saving: false,
      profileData: null,
    };
  },

  computed: {
    ...mapGetters("connections", ["currencySymbol"]),
  },

  created() {
    if (this.roleData) {
      this.getFamilyRole();
    }
  },

  watch: {
    roleData: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getFamilyRole();
        }
      },
    },
  },

  methods: {
    defaultExtraFields(data) {
      let newData = data;
      if (
        typeof newData.extra.transparency === "string" ||
        newData.extra.transparency === undefined
      )
        newData.extra.transparency = {};
      if (!data.extra.transparency.hasOwnProperty("biodiversity"))
        newData.extra.transparency.biodiversity = "";
      if (!data.extra.transparency.hasOwnProperty("soil"))
        newData.extra.transparency.soil = "";
      if (!data.extra.transparency.hasOwnProperty("animals"))
        newData.extra.transparency.animals = "";
      if (!data.extra.transparency.hasOwnProperty("climate"))
        newData.extra.transparency.climate = "";
      if (!data.extra.transparency.hasOwnProperty("cycles"))
        newData.extra.transparency.cycles = "";
      if (!data.extra.transparency.hasOwnProperty("diversification"))
        newData.extra.transparency.diversification = "";
      if (!data.extra.transparency.hasOwnProperty("type"))
        newData.extra.transparency.type = "";
      if (!data.extra.transparency.hasOwnProperty("team"))
        newData.extra.transparency.team = "";
      if (!data.extra.transparency.hasOwnProperty("regionalwertUrl"))
        newData.extra.transparency.regionalwertUrl = "";
      return newData;
    },

    getFamilyRole() {
      let data = this.defaultExtraFields(this.roleData);
      this.profileData = data;
    },

    prepareProfileData(data) {
      let profileData = {
        id: this.$store.state.role.id,
        info_contact: data.info_contact,
        desc_zone: data.desc_zone,
        desc_short: data.desc_short,
      };
      return profileData;
    },

    async onSubmit() {
      this.saving = true;
      const roleId = this.$store.state.role.id;
      const requestParams = this.prepareProfileData(this.profileData);

      const response = await apiPatch("auth_frole", roleId, requestParams);
      if (response && response.status === 200) {
        this.saving = false;
        this.$store.dispatch("toaster/add", {
          title: "OK!",
          text: this.$t("role.finance.invoicesSettings.success"),
          color: "success",
          autohide: true,
        });
      } else {
        console.error("Unexpected response:", response);
        this.saving = false;
        Object.entries(response).forEach(([key, value]) => {
          this.$store.dispatch("toaster/add", {
            title: this.$t("common.general.savingError"),
            text: `${key}: ${value}`,
            color: "danger",
            autohide: true,
          });
        });
      }
    },
  },
};
</script>
